import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./ChangePassword.css";
import { useTranslation } from "react-i18next";
import click from "./assets/sounds/click.mp3";

export default function ChangePassword({}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { profile, token: stateToken } = location.state || {};
  const token = stateToken || localStorage.getItem("token");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const API_URL = process.env.REACT_APP_API_URL;

  const playSound = (sound) => {
      const audio = new Audio(sound);
      audio.play();
      };

      const {t} = useTranslation();


  const handleChangePassword = async () => {
    setError("");
    setSuccess("");


    

    if (newPassword !== confirmPassword) {
      setError(t("errors.passwordMismatch"));
      return;
    }

    try {
      const res = await fetch(`${API_URL}/api/auth/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ oldPassword, newPassword, lang: t.language }),
      });

      // Si le serveur renvoie autre chose que JSON, log le texte pour debug
      if (!res.ok) {
        const text = await res.text();
        console.error("Erreur serveur :", text);
        setError(t("errors.serverError"));
        return;
      }
      
      const data = await res.json();
      setSuccess(data.message || t("success.passwordChanged"));
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      console.error(err);
      setError(t("errors.serverError"));
    }
      
  };

  return (
    <div className="change-password-container">
      <h2>{t("changePassword.title")}</h2>

      <input
        type="password"
        placeholder={t("changePassword.oldPassword")}
        value={oldPassword}
        onChange={(e) => setOldPassword(e.target.value)}
      />
      <input
        type="password"
        placeholder={t("changePassword.newPassword")}
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />
      <input
        type="password"
        placeholder={t("changePassword.confirmPassword")}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />

      {error && <p className="error-msg">{error}</p>}
      {success && <p className="success-msg">{success}</p>}

      <div className="button-group">
        <button className="bg-Purple-700" onClick={() => {playSound(click);handleChangePassword()}}>
          {t("changePassword.submit")}
        </button>
        <button className="back-btn" onClick={() => {playSound(click);navigate(-1)}}>
        ←
        </button>
      </div>
    </div>
  );
}
